import styled from 'styled-components'
import Button from 'components/base-ui/Button'
import Fonts, { weight } from 'components/base-ui/Fonts'
import media from 'styles/media'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.colors.white};
  width: 100%;
`

const Image = styled.img`
  flex-shrink: 0;
  object-fit: cover;
  width: 64px;
  height: 64px;
  border-radius: 4px;
`

const Details = styled.div`
  min-height: 64px;
  align-self: start;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 4px;
  flex-grow: 1;
  padding-left: 16px;

  @media (${media.screenSmMiniMax}) {
    padding-left: 8px;
  }
`

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 4px;
`

const Info = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 6px;
`

const Period = styled(Fonts.SmallTitleRegular)`
  font-size: 10px;
  color: ${({ theme }) => theme.colors.darkGrey};
`

const PointsRequired = styled(Fonts.SmallTitleBold)<{ inActive: boolean }>`
  font-size: 10px;
  color: ${({ theme, inActive }) => (inActive ? theme.colors.darkGrey : theme.colors.primary)};
`

const RedeemButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: end;
  align-self: end;
`

const RedeemButton = styled(Button)`
  min-width: fit-content;
  padding: 4px 8px;
  min-height: 30px;
  border-radius: 4px;

  .content-wrapper {
    font-size: 12px;
    font-weight: ${weight.semiBold};
    width: fit-content;
    white-space: nowrap;
  }
`

export { Wrapper, Image, Details, Period, PointsRequired, RedeemButtonWrapper, RedeemButton, FlexContainer, Info }
